module.exports = __webpack_public_path__ + "img/hyundai02.ac308919.png";